import { observable, action, computed } from "mobx";
class ImageCaptureStore {
    @observable imageBytes: Uint8Array | null = null;
    @observable isLoading: boolean = false;
    @observable error: string | null = null;
    @observable uploadStatus: "idle" | "uploading" | "success" | "error" = "idle";
    @observable public jwt: string = "";

    @computed get imageBase64(): string | null {
        const bytes = this.imageBytes;
        if (!bytes) {
            return null;
        }
        const len = bytes.length;
        const chars = [];
        for (let i = 0; i < len; i++) {
            chars.push(String.fromCharCode(bytes[i]));
        }
        return window.btoa(chars.join(''));
    }

    @action setImageBytes(bytes: Uint8Array) {
        this.imageBytes = bytes;
    }

    @action clearImage() {
        this.imageBytes = null;
    }

    @action setLoading(loading: boolean) {
        this.isLoading = loading;
    }

    @action setError(error: string | null) {
        this.error = error;
    }

    @action setUploadStatus(status: "idle" | "uploading" | "success" | "error") {
        this.uploadStatus = status;
    }

    @action setJwt(jwt: string) {
        this.jwt = jwt;
    }
}

export default ImageCaptureStore;
